import React from 'react';
import clsx from 'clsx';

const Quote = ({ colour, width='35', height='31' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 35 31" fill="none">
      <path className={clsx({[`fill-${colour}`]:colour})} d="M1.74531 30.765C0.581771 25.5943 0 21.1065 0 17.3016C0 11.8382 1.2605 7.74063 3.78151 5.00892C6.30252 2.17965 9.98707 0.765015 14.8352 0.765015V6.61867C12.3142 6.61867 10.4719 7.3016 9.30834 8.66746C8.24176 10.0333 7.70847 12.0821 7.70847 14.8138V18.1796H14.9806V30.765H1.74531ZM21.3801 30.765C20.2165 25.5943 19.6348 21.1065 19.6348 17.3016C19.6348 11.8382 20.8953 7.74063 23.4163 5.00892C25.9373 2.17965 29.6218 0.765015 34.4699 0.765015V6.61867C31.9489 6.61867 30.1067 7.3016 28.9431 8.66746C27.8765 10.0333 27.3432 12.0821 27.3432 14.8138V18.1796H34.6154V30.765H21.3801Z" fill="#FFCC33"/>
    </svg>
  )
}

export default Quote
